export const setCountJs = (js: string) => {
	if (!js) return
	const scriptEl = document.getElementById('count_js')
	if (scriptEl) scriptEl.innerHTML = js
}
export const setIcon = (icon: string) => {
	document.querySelector("link[rel='icon']")?.setAttribute('href', icon)
}
export const setMeta = (name: string, content: string) => {
	let meta = document.querySelector(`meta[name="${name}"]`)
	if (!meta) {
		meta = document.createElement('meta')
		meta.setAttribute('name', name)
		document.head.appendChild(meta)
	}
	meta.setAttribute('content', content)
}
export const setTitle = (title: string) => {
	document.title = title
}
